import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

// @rosetta DNA2 libraries selector and reducer hookup
import { authReducer } from '@rosetta/react-auth';
import { lionReducer } from '@rosetta/react-lion';

// app module reducers
import { appReducer } from './modules/app/reducer/app-reducer';
import { exportReducer } from './modules/launchpad/reducer/export-reducer';
import { goalsReducer } from './modules/launchpad/reducer/goals-reducer';
import { launchpadReducer } from './modules/launchpad/reducer/launchpad-reducer';
import { passwordChangeReducer } from './modules/login/reducer/password-change-reducer';
import { preferencesReducer } from './modules/preferences/reducer/preferences-reducer';
import { questionnaireReducer } from './modules/questionnaire/reducer/questionnaire-reducer';
import { registerReducer } from './modules/register/reducer/register-reducer';
import { ssoLoginReducer } from './modules/login/reducer/sso-login-reducer';

export const rootReducer = (history) =>
  combineReducers({
    app: appReducer,
    auth: authReducer,
    export: exportReducer,
    goals: goalsReducer,
    launchpad: launchpadReducer,
    lion: lionReducer,
    passwordChange: passwordChangeReducer,
    preferences: preferencesReducer,
    questionnaire: questionnaireReducer,
    register: registerReducer,
    router: connectRouter(history),
    ssoLogin: ssoLoginReducer
  });



// WEBPACK FOOTER //
// ./src/root-reducer.js